import { TermsConditions, CreateTermsConditionsRequest } from "../types/working-model";
import { Get, Post, Put } from "./helpers";

export function GetTermsConditions(terms_id: number): Promise<TermsConditions> {
	return Get(`/v3/admin/events/terms-conditions/${terms_id}`, "");
}

export function CreateTermsConditions(newTerms: CreateTermsConditionsRequest, token: string): Promise<TermsConditions> {
	return Post(`/v3/admin/events/terms-conditions`, token, newTerms);
}

export function UpdateTermsConditions({ terms_id, content, settings }: TermsConditions, token: string): Promise<TermsConditions> {
	return Put(`/v3/admin/events/terms-conditions/${terms_id}`, token, { content, settings }, true);
}
